import React from "react";
import { Trash } from "lucide-react";

export function ScheduledVariantHeader({ variant, isLoading, onDelete }) {
  return (
    <div className="flex sm:flex-row flex-col justify-between mb-8">
      <div className="sm:w-1/2 w-full">
        <h1 className="text-2xl font-bold mb-2">
          {isLoading ? "Loading..." : variant?.name ? variant.name : "..."}
        </h1>
      </div>

      {/* button to delete this scheduled variant */}
      <div className="flex items-center sm:mt-0 mt-4">
        <button onClick={onDelete} className="bg-slate-100 rounded-md p-2 ml-3">
          <Trash size={17} />
        </button>
      </div>
    </div>
  );
}
